<template>
    <div class="startdesk-list">
        <div class="startdesk-list__header" v-if="showTitle">
            <h2 class="view__title startdesk-list__title">{{ __('My Startdesks') }}</h2>
        </div>

        <div class="filters startdesk-list__filters" v-if="showFilters">
            <div class="category-list">
                <a class="category-list__item" v-if="showBackButton" v-on:click="handleCategoryBack()">
                    {{ __('Back') }}
                </a>
                <router-link class="category-list__item"
                             v-bind:to="{ name: 'startdesks.add' }"
                             v-if="false && showBackButton"
                >
                    {{ __('Back') }}
                </router-link>
            </div>

            <category-list category-type="startdesks"
                           v-bind:list-link="{ name: 'startdesks.add' }"
                           v-bind:parent-id="category"
                           v-if="showFilters['category'] && listType == 'add'"
            />

            <category-list category-type="startdesks"
                           v-bind:active-category="categoryFilter"
                           v-bind:parent-category-name="categoryFilter"
                           v-bind:parent-id="categoryFilter"
                           v-bind:show-all="true"
                           v-if="showFilters['category'] && listType == 'list'"
            />

            <div class="form is-horizontal">

                <div class="form__group" v-if="showFilters['created_at']">
                    <label class="form__label" for="creation_date">{{ __('Date created') }}</label>
                    <v-date-picker mode="range" show-caps
                                   v-bind:input-props="{ 'class' : 'form__control', 'id' : 'creation_date', placeholder: __('Choose dates') }"
                                   v-model="createdAt"
                                   v-on:input="getStartdesks(true)"
                    >
                    </v-date-picker>
                </div>

                <div class="form__group" v-if="showFilters['updated_at']">
                    <label class="form__label" for="update_date">{{ __('Last updated') }}</label>
                    <v-date-picker mode="range" show-caps
                                   v-bind:input-props="{ 'class' : 'form__control', 'id' : 'update_date', placeholder: __('Choose dates') }"
                                   v-model="updatedAt"
                                   v-on:input="getStartdesks(true)"
                    >
                    </v-date-picker>
                </div>

                <div class="form__group" v-if="showFilters['user_type']">
                    <label class="form__label" for="user_type">{{ __('Owner type') }}</label>
                    <select class="form__control" id="user_type"
                            v-model="userType"
                            v-on:change="getStartdesks(true)"
                    >
                        <option value="-1">Superadmin & Admin</option>
                        <option value="1">Superadmin</option>
                        <option value="2">Admin</option>
                        <option value="3">User</option>
                    </select>
                </div>

                <div class="form__group" v-if="showFilters['is_default']">
                    <label class="form__label" for="is_default">{{ __('Is default?') }}</label>
                    <select class="form__control" id="is_default"
                            v-model="isDefault"
                            v-on:change="getStartdesks(true)"
                    >
                        <option value="2">All</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>

                <div class="form__group" v-if="showFilters['is_active_admin']">
                    <label class="form__label" for="is_active_admin">{{ __('Is active for admin?') }}</label>
                    <select class="form__control" id="is_active_admin"
                            v-model="isActiveAdmin"
                            v-on:change="getStartdesks(true)"
                    >
                        <option value="2">All</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>

                <div class="form__group" v-if="showFilters['is_visible_to_user']">
                    <label class="form__label" for="is_visible_to_user">{{ __('Is visible to user?') }}</label>
                    <select class="form__control" id="is_visible_to_user"
                            v-model="isVisibleToUser"
                            v-on:change="getStartdesks(true)"
                    >
                        <option value="2">All</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>

            <div class="form is-horizontal">
                <div class="form__group" v-if="showFilters['search']">
                    <label class="form__label" for="search" autocomplete="off">{{ __('Search') }}</label>
                    <input class="form__control" id="search"
                            v-model="search"
                            v-on:change="getStartdesks(true)"
                    />
                </div>

                <div class="form__group" v-if="showFilters['search_by_owner']">
                    <label class="form__label" for="search_by_owner" autocomplete="off">{{ __('Owner name') }}</label>
                    <input class="form__control" id="search_by_owner"
                           v-model="searchByOwner"
                           v-on:change="getStartdesks(true)"
                    />
                </div>

                <div class="form__group" v-if="showSort">
                    <label class="form__label" for="sort">{{ __('Sort by') }}</label>
                    <select class="form__control" id="sort"
                            v-model="sort"
                            v-on:change="getStartdesks(true)"
                    >
                        <option value="name_asc">Name (A-Z)</option>
                        <option value="name_desc">Name (Z-A)</option>
                        <option value="created_at">Date created</option>
                        <option value="updated_at">Last updated</option>
                    </select>
                </div>
            </div>
        </div>

        <router-link class="btn has-margin-b30 is-pulled-left is-primary"
                     v-bind:to="{ name: 'startdesks.add', params: { category: 'custom' } }"
                     v-if="listType == 'list' && user.is_admin"
        >
            <span class="jam jam-plus"></span> {{ __('Add startdesk') }}
        </router-link>

        <nav class="startdesk-list__startdesks" v-if="startdesks && startdesks.length > 0">
            <router-link class="startdesk-list__add-startdesk"
                         v-bind:to="{ name: 'startdesks.add' }"
                         v-if="showAddButton"
                    >
                <span class="jam jam-plus-circle"></span>
                <h2 class="view__title startdesk-list__title" style="text-align: center;">Add new startdesk</h2>
            </router-link>
            <startdesk v-bind:draggable="sortable"
                       v-bind:key="startdesk.id"
                       v-bind:selectable="selectable"
                       v-bind:show-actions="showActions"
                       v-bind:show-add-to-my-startdesks-button="showAddToMyStartdesksButton"
                       v-bind:show-select-action="showBulkActions"
                       v-bind:startdesk="startdesk"
                       v-for="startdesk in startdesks"
            />
        </nav>

        <a class="btn btn-primary has-margin-r30 is-pulled-left"
           v-html="
                selectedStartdesks.length == paging.to - paging.from + 1
                ? __('Select none')
                : __('Select all')
           "
           v-if="showBulkActions && startdesks.length > 0"
           v-on:click="selectAllStartdesks"
        ></a>

        <div class="startdesk-list__bulk-actions" v-if="showBulkActions && selectedStartdesks.length > 0">
            <a class="btn is-pulled-left"
               v-on:click="openDeleteConfirmModal('delete-selected-startdesks')"
            >
                {{ __('Delete selected') }}
            </a>
            <confirm-modal
                    v-bind:id="'delete-selected-startdesks'"
                    v-bind:text="__('Are you sure you wish to delete all selected startdesks?')"
            ></confirm-modal>
        </div>

        <button class="btn is-primary startdesk-list__add-btn" type="button"
                v-if="listType == 'add' && startdesks.length > 0 && selectedStartdesks.length > 0"
                v-on:click="handleAdd"
                >
            {{ __('Add selected startdesks') }}
        </button>

        <p v-if="!startdesks">{{ __('Loading startdesks&hellip;') }}</p>
        <p v-if="startdesks && startdesks.length == 0">{{ __('You have no startdesks.') }}</p>

        <paging v-bind:paging="paging" v-if="showPaging"></paging>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import categoryList from './CategoryList.vue';
    import confirmModal from '../elements/ConfirmModal.vue';
    import paging from '../elements/Paging.vue';
    import startdesk from './Startdesk.vue';

    export default {
        components: {
            categoryList,
            confirmModal,
            paging,
            startdesk
        },
        data: function () {
            return {
                categoryFilter: this.category,
                categoryFilterHistory: [],
                createdAt: {
                    start: null,
                    end: null
                },
                isActiveAdmin: 2,
                isDefault: 2,
                isVisibleToUser: 2,
                paging: {
                    current: 1,
                    from: 1,
                    lastPage: 1,
                    perPage: this.showPaging ? 50 : 0,
                    to: 1,
                    total: 0
                },
                search: null,
                searchByOwner: null,
                selectedStartdesks: [],
                sort: this.sortable ? 'order' : 'name_asc',
                startdesks: [],
                updatedAt: {
                    start: null,
                    end: null
                },
                userType: -1
            }
        },
        methods: {
            getStartdesks: function (resetPaging = false) {
                this.startdesks = [];
                if (resetPaging) {
                    this.paging.current = 1;
                }

                let filters = {};

                if (this.categoryFilter) {
                    filters.category = this.categoryFilter;
                }
                if (this.createdAt) {
                    if (this.createdAt.start)
                        filters.creation_date_from = this.createdAt.start.getFullYear() + "-" + ("0"+(this.createdAt.start.getMonth()+1)).slice(-2) + "-" + ("0" + this.createdAt.start.getDate()).slice(-2) + ' user:00';
                    if (this.createdAt.end)
                        filters.creation_date_to = this.createdAt.end.getFullYear() + "-" + ("0"+(this.createdAt.end.getMonth()+1)).slice(-2) + "-" + ("0" + this.createdAt.end.getDate()).slice(-2) + ' 23:59';
                }
                if (this.isActiveAdmin && this.isActiveAdmin != 2) {
                    filters.is_active_admin = this.isActiveAdmin;
                }
                if (this.isDefault && this.isDefault != 2) {
                    filters.is_default = this.isDefault;
                }
                if (this.isVisibleToUser && this.isVisibleToUser != 2) {
                    filters.is_visible_to_user = this.isVisibleToUser;
                }
                if (this.isVisibleToUserFilter) {
                    filters.is_visible_to_user = this.isVisibleToUserFilter;
                }
                if (this.search) {
                    filters.search = this.search;
                }
                if (this.searchByOwner) {
                    filters.search_by_owner = this.searchByOwner;
                }
                if (this.updatedAt) {
                    if (this.updatedAt.start)
                        filters.update_date_from = this.updatedAt.start.getFullYear() + "-" + ("0"+(this.updatedAt.start.getMonth()+1)).slice(-2) + "-" + ("0" + this.updatedAt.start.getDate()).slice(-2) + ' 00:00';
                    if (this.updatedAt.end)
                        filters.update_date_to = this.updatedAt.end.getFullYear() + "-" + ("0"+(this.updatedAt.end.getMonth()+1)).slice(-2) + "-" + ("0" + this.updatedAt.end.getDate()).slice(-2) + ' 23:59';
                }
                if (this.user) {
                    filters.user = this.userId;
                }
                if (this.userType) {
                    filters.user_type = this.userType == -1 ? 0 : this.userType;
                }

                let sortBy = 'name';
                let sortOrder = 'asc';

                switch (this.sort) {
                    case 'name_asc':
                        sortBy = 'name';
                        sortOrder = 'asc';

                        break;
                    case 'name_desc':
                        sortBy = 'name';
                        sortOrder = 'desc';

                        break;
                    default:
                        sortBy = this.sort;
                        sortOrder = 'desc';
                }

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/startdesks', {
                    params : {
                        filters: filters,
                        page: this.paging.current,
                        perPage: this.paging.perPage,
                        sortBy: sortBy,
                        sortOrder: sortOrder
                    }
                }).then(function (response) {
                    this.paging.from = response.body.original.from;
                    this.paging.lastPage = response.body.original.last_page;
                    this.paging.to = response.body.original.to;
                    this.paging.total = response.body.original.total;

                    this.startdesks = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleAdd: function (e) {
                let promises = [];

                this.selectedStartdesks.forEach(function (startdesk) {
                    promises.push(this.$http.put(this.apiUrl + '/startdesks/' + startdesk.id + '/' + this.user.id));
                }.bind(this));

                eventBus.$emit('show-loader');

                Promise.all(promises).then(function (response) {
                    eventBus.$emit('hide-loader');

                    let startdesk = null;

                    response.forEach(function (item) {
                        this.myStartdesks.push(item.data);
                        startdesk = item.data;
                    }.bind(this));

                    this.myStartdesks.sort(function(a, b) {
                        return  a.name.localeCompare(b.name);
                    });

                    eventBus.$emit('show-alert', 'success', this.__('Startdesk successfully added to my startdesks.'));

                    this.viewStartdesk(startdesk);

                    this.$router.push({
                        name: 'startdesks.view',
                        params: { startdesk: startdesk.slug, u: startdesk.is_user_startdesk }
                    });
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            },
            handleReorder: function (dragged, target) {
                // dragged is the element that was dragged
                // target was the element that dragged was dropped onto
                // dragged should be placed before target
                if (dragged != target) {

                    var sortedStartdesks = [];
                    var draggedStartdesk = null;

                    for (var i = 0; i < this.startdesks.length; i++) {
                        if (dragged == this.startdesks[i].id) {
                            draggedStartdesk = this.startdesks[i];
                            break;
                        }
                    }

                    this.startdesks.forEach(function (startdesk) {
                        if (dragged != startdesk.id) {
                            if (target == startdesk.id) {
                                sortedStartdesks.push(draggedStartdesk);
                            }

                            sortedStartdesks.push(startdesk);
                        }
                    });

                    this.startdesks = sortedStartdesks;
                    this.$http.patch(this.apiUrl +  '/startdesks/reorder', {
                        startdesks: sortedStartdesks
                    });
                }
            },
            init: function () {
                this.getStartdesks(true);
                if (this.category)
                    this.categoryFilterHistory.push(this.category);
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            selectAllStartdesks: function () {
                if (this.selectedStartdesks.length == this.paging.to - this.paging.from + 1) {
                    eventBus.$emit('deselect-all-startdesks');
                } else {
                    eventBus.$emit('select-all-startdesks');
                }
            },
            updateCategory: function (category) {
                this.categoryFilter = category;
            },
            updatePaging: function (newPage, perPage) {
                if (newPage || perPage != this.paging.perPage) {
                    if (newPage) {
                        this.paging.current = newPage;
                    }
                    this.paging.perPage = perPage;

                    this.getStartdesks();
                }
            },
            handleCategoryBack: function () {
                let $prevCategoryFilter = this.categoryFilterHistory.pop();
                $prevCategoryFilter = this.categoryFilterHistory.pop();
                
                if ($prevCategoryFilter)
                    this.category = $prevCategoryFilter;
                else
                    this.$router.push({ name: 'startdesks.add' });
            },
        },
        mounted: function () {
            this.init();
        },
        props: {
            category: {
                default: null,
                type: Number
            },
            isVisibleToUserFilter: {
                default: false,
                type: Boolean
            },
            listType: {
                default: 'list',
                type: String
            },
            selectable: {
                default: false,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            },
            showAddButton: {
                default: true,
                type: Boolean
            },
            showAddToMyStartdesksButton: {
                default: false,
                type: Boolean
            },
            showBackButton: {
                default: false,
                type: Boolean
            },
            showBulkActions: {
                default: false,
                type: Boolean
            },
            showFilters: {
                default: null,
                type: Object
            },
            showPaging: {
                default: false,
                type: Boolean
            },
            showSort: {
                default: false,
                type: Boolean
            },
            showTitle: {
                default: true,
                type: Boolean
            },
            sortable: {
                default: false,
                type: Boolean
            },
            userId: {
                default: null,
                type: Number
            }
        },
        watch: {
            category: function () {
                this.categoryFilter = this.category;
                this.categoryFilterHistory.push(this.category);
            },
            categoryFilter: function () {
                this.getStartdesks(true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/StartdeskList.vue